import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(private apiService: ApiBaseService) { }

  getProjectComments(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/GetProjectComments', payload, true, true);
  }

  getGridConnectionComments(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/GetGridConnectionComments', payload, true, true);
  }

  getTaskComments(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/GetProjectTaskComments', payload, true, true);
  }

  addProjectComment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/AddProjectComment', payload, true, true);
  }

  addGridConnectionComment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/AddGridConnectionComment', payload, true, true);
  }

  addProjectTaskComment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/AddProjectTaskComment', payload, true, true)
  }

  getComments(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/GetComments', payload, true, true)
  }

  addComment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/AddComment', payload, true, true)
  }

  addCommentAttachment(payload: any): Promise<any> {
    return this.apiService.httpRequestForm('CommentService/AddCommentAttachment', payload, true, true)
  }

  deleteCommentAttachment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/DeleteCommentAttachment', payload, true, true)
  }

  openCommentAttachment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/OpenCommentAttachment', payload, true, true)
  }


  deleteComment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/DeleteComment', payload, true, true)
  }


}
